import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ja'
Vue.use(ElementUI, { locale })

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
Vue.use(Buefy)

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
// set default config
Vue.$cookies.config('7d')

import '@fortawesome/fontawesome-free/css/all.css'

import VueMq from 'vue-mq'
const breakpoints = {
  sp: 1024,
  pc: Infinity
}
Vue.use(VueMq, { breakpoints })

import '@/tcw/domain/types'
import '@/plugins/FormComponentRegister'

import TCardWebAllPlugin from '@/plugins/TCardWebAllPlugin'
Vue.use(TCardWebAllPlugin, { store })

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
